import {
  GET_CUSTOM_FORM_DATA_FOR_ALIAS,
  GET_ZIP_FROM_CUSTOM_FORM,
} from '../getterTypes';
import {CUSTOM_FORM_ALIASES} from '@/const';

export default {
  [GET_CUSTOM_FORM_DATA_FOR_ALIAS]: (state) => (alias) => {
    return alias && state.customForm[alias] || state.customForm;
  },
  [GET_ZIP_FROM_CUSTOM_FORM]: (state) => {
    const userForm = state.customForm[CUSTOM_FORM_ALIASES.USER];
    const zipAliases = ['zip', 'postal_code', 'zip_plus_four'];
    return userForm?.find(({name}) => zipAliases.includes(name))?.value || '';
  },
};
